import { render, staticRenderFns } from "./SuggestionItemWarningApiToken.vue?vue&type=template&id=3e3390cd&scoped=true&"
import script from "./SuggestionItemWarningApiToken.vue?vue&type=script&lang=ts&"
export * from "./SuggestionItemWarningApiToken.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestionItemWarningApiToken.vue?vue&type=style&index=0&id=3e3390cd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3390cd",
  null
  
)

export default component.exports